import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {inject} from '@angular/core';
import {getUser} from '@portal-workspace/grow-ui-library';
import {AuthService} from '../service/auth.service';



export const alreadyLoginGuard = () => {
  return async (
    route: ActivatedRouteSnapshot, state: RouterStateSnapshot
  ) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const user = getUser();
    if (user) {
      await authService.redirectUser(router, user);
    }
    return true;
  }
}
